import { HTTP_API_V2 } from '../../http-common'

export default {
  state: {
    loadedSubscriptionDevicesV2: []
  },
  getters: {
    loadedSubscriptionDevicesV2 (state) {
      return state.loadedSubscriptionDevicesV2
    }
  },
  mutations: {
    setLoadedSubscriptionDevicesV2 (state, payload) {
      state.loadedSubscriptionDevicesV2 = payload
    }
  },
  actions: {
    loadSubscriptionDevicesV2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedSubscriptionDevicesV2', [])
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('subscription-devices', {
          params: {
            deviceIds: payload && payload.deviceIds ? JSON.stringify(payload.deviceIds) : null
          }
        })
        .then(result => {
          const retroCompatibleResult = result.data
            .map(subscriptionDevice => {
              return {
                id: subscriptionDevice.id,
                device: subscriptionDevice.device,
                subscription: subscriptionDevice.subscription,
                created_at: subscriptionDevice.created_at,
                updated_at: subscriptionDevice.updated_at
              }
            })
          commit('setLoadedSubscriptionDevicesV2', retroCompatibleResult)
          resolve(retroCompatibleResult)
        })
        .catch(err => {
          console.log(err)
          commit('setError', err.message)
        })
        .finally(() => {
          commit('setLoading', false)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/subscription_device/index.js